import { Card, CardBody, TableControl, TableSkeleton } from '@/_components';
import { ContainerLayout, StickyPageHeaderSkeletonWithButtons } from '@/_containers';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={1} />

      <div className="mt-6 px-6">
        <Card>
          <CardBody className="space-y-4">
            <TableControl />

            <TableSkeleton numberOfColumns={8} />
          </CardBody>
        </Card>
      </div>
    </ContainerLayout>
  );
}
